/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.StrategyBusinessReviewExportSettings = factory(root.ForStractionServiceApi.ApiClient);
  }
}(this, function(ApiClient) {
  'use strict';




  /**
   * The StrategyBusinessReviewExportSettings model module.
   * @module model/StrategyBusinessReviewExportSettings
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>StrategyBusinessReviewExportSettings</code>.
   * @alias module:model/StrategyBusinessReviewExportSettings
   * @class
   */
  var exports = function() {
    var _this = this;

















  };

  /**
   * Constructs a <code>StrategyBusinessReviewExportSettings</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/StrategyBusinessReviewExportSettings} obj Optional instance to populate.
   * @return {module:model/StrategyBusinessReviewExportSettings} The populated <code>StrategyBusinessReviewExportSettings</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('TextFilter')) {
        obj['TextFilter'] = ApiClient.convertToType(data['TextFilter'], ['String']);
      }
      if (data.hasOwnProperty('StrategyDescriptionIDs')) {
        obj['StrategyDescriptionIDs'] = ApiClient.convertToType(data['StrategyDescriptionIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('ResponsibleUserIDs')) {
        obj['ResponsibleUserIDs'] = ApiClient.convertToType(data['ResponsibleUserIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('ResponsibleCompanyFunctionIDs')) {
        obj['ResponsibleCompanyFunctionIDs'] = ApiClient.convertToType(data['ResponsibleCompanyFunctionIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('ResponsibleVirtualTeamIDs')) {
        obj['ResponsibleVirtualTeamIDs'] = ApiClient.convertToType(data['ResponsibleVirtualTeamIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('MilestoneCompanyFunctionIDs')) {
        obj['MilestoneCompanyFunctionIDs'] = ApiClient.convertToType(data['MilestoneCompanyFunctionIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('MilestoneVirtualTeamIDs')) {
        obj['MilestoneVirtualTeamIDs'] = ApiClient.convertToType(data['MilestoneVirtualTeamIDs'], ['Integer']);
      }
      if (data.hasOwnProperty('PeriodTypeID')) {
        obj['PeriodTypeID'] = ApiClient.convertToType(data['PeriodTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('ViewTypeID')) {
        obj['ViewTypeID'] = ApiClient.convertToType(data['ViewTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('CurrentPeriodTitle')) {
        obj['CurrentPeriodTitle'] = ApiClient.convertToType(data['CurrentPeriodTitle'], 'String');
      }
      if (data.hasOwnProperty('CurrentPeriodStartDate')) {
        obj['CurrentPeriodStartDate'] = ApiClient.convertToType(data['CurrentPeriodStartDate'], 'Date');
      }
      if (data.hasOwnProperty('CurrentPeriodEndDate')) {
        obj['CurrentPeriodEndDate'] = ApiClient.convertToType(data['CurrentPeriodEndDate'], 'Date');
      }
      if (data.hasOwnProperty('PrevPeriodStartDate')) {
        obj['PrevPeriodStartDate'] = ApiClient.convertToType(data['PrevPeriodStartDate'], 'Date');
      }
      if (data.hasOwnProperty('PrevPeriodEndDate')) {
        obj['PrevPeriodEndDate'] = ApiClient.convertToType(data['PrevPeriodEndDate'], 'Date');
      }
      if (data.hasOwnProperty('PageOrientationID')) {
        obj['PageOrientationID'] = ApiClient.convertToType(data['PageOrientationID'], 'Integer');
      }
      if (data.hasOwnProperty('SvgImageDataUrls')) {
        obj['SvgImageDataUrls'] = ApiClient.convertToType(data['SvgImageDataUrls'], ['String']);
      }
    }
    return obj;
  }

  /**
   * @member {Array.<String>} TextFilter
   */
  exports.prototype['TextFilter'] = undefined;
  /**
   * @member {Array.<Integer>} StrategyDescriptionIDs
   */
  exports.prototype['StrategyDescriptionIDs'] = undefined;
  /**
   * @member {Array.<Integer>} ResponsibleUserIDs
   */
  exports.prototype['ResponsibleUserIDs'] = undefined;
  /**
   * @member {Array.<Integer>} ResponsibleCompanyFunctionIDs
   */
  exports.prototype['ResponsibleCompanyFunctionIDs'] = undefined;
  /**
   * @member {Array.<Integer>} ResponsibleVirtualTeamIDs
   */
  exports.prototype['ResponsibleVirtualTeamIDs'] = undefined;
  /**
   * @member {Array.<Integer>} MilestoneCompanyFunctionIDs
   */
  exports.prototype['MilestoneCompanyFunctionIDs'] = undefined;
  /**
   * @member {Array.<Integer>} MilestoneVirtualTeamIDs
   */
  exports.prototype['MilestoneVirtualTeamIDs'] = undefined;
  /**
   * @member {Integer} PeriodTypeID
   * @default 0
   */
  exports.prototype['PeriodTypeID'] = 0;
  /**
   * @member {Integer} ViewTypeID
   * @default 0
   */
  exports.prototype['ViewTypeID'] = 0;
  /**
   * @member {String} CurrentPeriodTitle
   * @default ''
   */
  exports.prototype['CurrentPeriodTitle'] = '';
  /**
   * @member {Date} CurrentPeriodStartDate
   */
  exports.prototype['CurrentPeriodStartDate'] = undefined;
  /**
   * @member {Date} CurrentPeriodEndDate
   */
  exports.prototype['CurrentPeriodEndDate'] = undefined;
  /**
   * @member {Date} PrevPeriodStartDate
   */
  exports.prototype['PrevPeriodStartDate'] = undefined;
  /**
   * @member {Date} PrevPeriodEndDate
   */
  exports.prototype['PrevPeriodEndDate'] = undefined;
  /**
   * @member {Integer} PageOrientationID
   * @default 0
   */
  exports.prototype['PageOrientationID'] = 0;
  /**
   * @member {Array.<String>} SvgImageDataUrls
   */
  exports.prototype['SvgImageDataUrls'] = undefined;



  return exports;
}));


